import { render, staticRenderFns } from "./MultiSelectSelectedItem.vue?vue&type=template&id=5058b160&scoped=true&functional=true&"
import script from "./MultiSelectSelectedItem.vue?vue&type=script&lang=js&"
export * from "./MultiSelectSelectedItem.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectSelectedItem.vue?vue&type=style&index=0&id=5058b160&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5058b160",
  null
  
)

export default component.exports